import { BreadcrumbList, ListItem, WebPage, WithContext } from 'schema-dts';

/**
 * Absolute URL for a site-relative path, e.g. `events/hybrid-events`.
 * `NEXT_PUBLIC_BASE_URL` already ends in a slash, so `path` must not start with
 * one — a leading slash yields a double slash in the emitted markup.
 */
export const getAbsoluteUrl = (path: string) => `${process.env.NEXT_PUBLIC_BASE_URL}${path}`;

interface IWebPageSchemaOptions {
  /** Site-relative path, no leading slash. */
  path: string;
  name: string;
  description: string;
}

/**
 * Baseline `WebPage` markup for a static marketing page. Gives crawlers an
 * explicit page-level topic, which the page's `<h1>` alone does not express in
 * machine-readable form.
 */
export const buildWebPageSchema = ({ path, name, description }: IWebPageSchemaOptions): WithContext<WebPage> => ({
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  url: getAbsoluteUrl(path),
  name,
  description,
  inLanguage: 'en',
  isPartOf: {
    '@type': 'WebSite',
    name: 'Underline',
    url: process.env.NEXT_PUBLIC_BASE_URL,
  },
});

/** A breadcrumb trail entry: display name plus site-relative path. */
export interface IBreadcrumb {
  name: string;
  path: string;
}

export const buildBreadcrumbSchema = (crumbs: Array<IBreadcrumb>): WithContext<BreadcrumbList> => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: crumbs.map(
    ({ name, path }, index): ListItem => ({
      '@type': 'ListItem',
      position: index + 1,
      name,
      item: getAbsoluteUrl(path),
    })
  ),
});
